"use client";


import {Button} from "@/components/ui/button";
import AuthAction from "@/components/site/AuthAction";
import axios from "@/lib/axios";
import {getSession, useSession} from "next-auth/react";
import {authOptions} from "@/lib/authOptions";
import toast from "react-hot-toast";
import {useState} from "react";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {Form} from "@/components/ui/form";
import {useForm, useWatch} from "react-hook-form";
import Link from "next/link";
import CWFCheckbox from "@/components/ui/CWFCheckbox";
import CWFRadioGroup from "@/components/ui/CWFRadioGroup";
import {CWFInput} from "@/components/ui/CWFInput";
import getStripe from "@/lib/utils/get-stripe";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
const REQUIRED_ERROR = "Ce champ est requis.";
const formParticipateSchema = yup.object({

    acompagnate : yup.number().oneOf([1,2], "Veuillez fournir une valeur correcte.").required(REQUIRED_ERROR),
    email : yup.string().email("Veuillez fournir une adresse email valide").when("acompagnate",{
        is : 2,
        then : schema => schema.required(REQUIRED_ERROR),
    }),
    firstname : yup.string().when("acompagnate",{
        is: 2,
        then : schema => schema.required(REQUIRED_ERROR),
    }),
    lastname : yup.string().when("acompagnate",{is: 2,
        then : schema => schema.required(REQUIRED_ERROR)}),
    terms: yup.boolean()
        .oneOf([true], "Vous devez accepter nos conditions de participations pour continuer.")
        .required("Vous devez accepter nos conditions de participations pour continuer."),
    is_gift : yup.boolean(),
})
export default function ApplyActivity({ activityId, onSuccess, price }) {
    const [participantOpen, setParticipantOpen] = useState(false);
    const axiosAuth = useAxiosAuth();
    const formParticipate = useForm({
        resolver : yupResolver(formParticipateSchema)
    });

    const accompagnate = useWatch({control : formParticipate.control, name:"acompagnate"})


    function preapply() {
        getSession(authOptions)
            .then(session => {
                setParticipantOpen(true);
            });
        //setParticipantOpen(true);
    }


    function addParticipants(data){
        getSession(authOptions)
            .then(session => {
                if(data.acompagnate === 1){
                    axios.post(`/activities/participants/${activityId}`, null, {
                        headers: {
                            Authorization: `Bearer ${session.user.token}`
                        }
                    })
                        .then(() => {
                            toast.success("Vous avez été préinscrit(e) avec succès.");
                            setParticipantOpen(false);
                            if(price){
                                axiosAuth.post('payments/create-session', {
                                    type : "ACT",
                                    activity_id:activityId,
                                    redirect_module:'activity',
                                    redirect_id : activityId
                                }).then(res => {
                                    getStripe().then(stripe => {
                                        stripe.redirectToCheckout({
                                            sessionId: res.data.data.session.id,
                                        })
                                    })
                                })

                            }else{
                                onSuccess?.();
                            }
                            //onSuccess?.();
                        })
                        .catch((err) => {
                            //console.log("test")
                            console.error(err.response.data);
                            if(err.response.status === 422){
                                toast.success("Vous êtes déjà préinscrit(e).")
                            }else{
                                toast.error("Une erreur est survenue lors de votre préinscription.")
                            }
                        });
                }else{
                    axios.post(`/activities/participants/${activityId}`, data, {
                        headers: {
                            Authorization: `Bearer ${session.user.token}`
                        }
                    })
                        .then(() => {

                            if(price){
                                axiosAuth.post('payments/create-session', {
                                    type : "ACT",
                                    activity_id:activityId,
                                    redirect_module:'activity',
                                    redirect_id : activityId
                                }).then(res => {
                                    getStripe().then(stripe => {
                                        stripe.redirectToCheckout({
                                            sessionId: res.data.data.session.id,
                                        })
                                    })
                                })

                            }else{
                                onSuccess?.();
                                toast.success("Vous avez été préinscrit(e) avec succès.");
                                setParticipantOpen(false);
                            }
                            //onSuccess?.();
                        })
                        .catch((err) => {
                            if(err.response.status === 422){
                                if(err.response.data.message === "Participant already exists"){
                                    toast.error("L'accompagnant est déjà inscrit a cette activité.")
                                }else if(err.response.data.message === "Participant is a cwf-member"){
                                    toast.error("L'accompagnant est déjà membre de coworkfit, il est conseillé qu'il s'inscrive lui même afin de bénéficier d'une meilleure experience.")
                                }else{
                                    toast.success("Vous êtes déjà préinscrit(e).")
                                }

                            }else{
                                toast.error("Une erreur est survenue lors de votre préinscription.")
                            }
                        });
                }
            })

    }



    return (


        <>
            <AuthAction
                trigger={(
                    <Button>
                        Inscription
                    </Button>
                )}
                action={preapply}
            />
            <CWFResponsiveDialog
                open={participantOpen}
                onOpenChange={setParticipantOpen}
                title={<p>M&apos;inscrire à l&apos;événement</p>}
                trigger={null}
            >
                <Form {...formParticipate}>
                    <form onSubmit={formParticipate.handleSubmit(addParticipants)} className={"grid grid-cols-2 gap-2"}>

                        <CWFRadioGroup
                            control={formParticipate.control}
                            name="acompagnate"
                            label="Je serai"
                            className="col-span-2 gap-3"
                            orientation="horizontal"
                            options={[
                                {label: "Seul", value: 1},
                                {label: "Accompagné", value: 2},
                            ]}
                        />
                        {accompagnate === 2 && (
                            <>
                                <CWFInput control={formParticipate.control} name="firstname" label="Prénom" className={"input-ios"}/>
                                <CWFInput control={formParticipate.control} name="lastname" label="Nom" className={"input-ios"}/>
                                <CWFInput control={formParticipate.control} name="email" label="Email" className={"col-span-2 input-ios"}/>
                            </>
                        )}


                        <CWFCheckbox
                            control={formParticipate.control} className="col-span-2" name="terms"
                            label="Conditions de Participation"
                            description={(
                                <span className="text-xs">
                                    J&apos;accepte de participer à l&apos;événement en toute connaissance des risques associés à l&apos;exercice physique. Je m&apos;engage à respecter les consignes de sécurité et à ne pas tenir les organisateurs responsables des éventuels accidents.
                                </span>
                            )}
                        />
                        {accompagnate === 2 && (
                            <CWFCheckbox
                                control={formParticipate.control}
                                className="col-span-2"
                                name="is_gift"
                                label={"Ceci est un cadeau"}
                                description={(
                                    <span className="text-xs">
                                   En cliquant, les autres participants ne recevront pas de mails automatiques de notre part afin de préserver la surprise.
                               </span>
                                )}
                            />
                        )}
                        <div className={"col-span-2 flex justify-center"}>
                            {/*<Button type={"submit"}>
                                {price ? "M'inscrire et payer" : "M'inscrire"}
                            </Button>*/}
                            <Button type={"submit"}>
                                {price ? "M'inscrire et payer" : "M'inscrire"}
                            </Button>

                        </div>

                    </form>



                </Form>
            </CWFResponsiveDialog>
        </>

    );
}